function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
  return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import qs from "query-string";
import { DOMAINS } from "./domain";
import { locales } from "./localization";
// @see https://stackoverflow.com/a/34773221
var hasExtension = function hasExtension(url) {
  return url.match(/\[\.#]([0-9a-z]+)(?=[?#])|([.#])(?:[\w]+)$/gi);
};
var addTrailingSlash = function addTrailingSlash(url) {
  return url.replace(/\/$|$/, "/");
};
var isTruthy = function isTruthy(i) {
  return Boolean(i);
};
var isNotHomepage = function isNotHomepage(segment) {
  var domainHomepages = Object.values(DOMAINS).map(function (domain) {
    var _domain_homepagePath;
    return (_domain_homepagePath = domain.homepagePath) === null || _domain_homepagePath === void 0 ? void 0 : _domain_homepagePath.replace("/", "");
  });
  return !domainHomepages.includes(segment);
};
var stripSlashes = function stripSlashes(segment, index) {
  if (index === 0) {
    return segment.replace(/^\/{2,}/g, "/").replace(/\/+$/g, "");
  }
  return segment.replace(/^\/+|\/+$/g, "");
};
/**
 * This function is for building URLs with query parameters.
 *
 * @param segments
 *  The segments of the URL to build.
 * @param query
 *  The query parameters to add to the URL.
 * @param queryOptions
 *  The options to pass to `qs.stringify`.
 */
export var buildUrl = function buildUrl(segments, query, queryOptions) {
  var sanitizedUrl = segments.filter(isTruthy).map(stripSlashes).filter(isNotHomepage).join("/");
  var _sanitizedUrl_split = _sliced_to_array(sanitizedUrl.split("?"), 2),
    url = _sanitizedUrl_split[0],
    queryFromUrl = _sanitizedUrl_split[1];
  var queryString = qs.stringify(query || {}, _object_spread({}, queryOptions));
  return [hasExtension(url) ? url : addTrailingSlash(url), queryString || queryFromUrl].filter(isTruthy).join("?");
};
/**
 * This function is a wrapper around `buildUrl` that adds the current URL as a query parameter.
 *
 * @param segments
 *  The segments of the URL to build.
 * @param query
 *  The query parameters to add to the URL.
 * @param queryOptions
 *  The options to pass to `qs.stringify`.
 * @param onlyContinueTracking
 *  Whether to only continue tracking the current URL.
 */
export var useRaisenowTrackingWithBuildUrl = function useRaisenowTrackingWithBuildUrl(segments, query, queryOptions, onlyContinueTracking) {
  var parameterKey = "rnw-stored_campaign_id";
  var _useLocation = _sliced_to_array(useLocation(), 1),
    location = _useLocation[0];
  var pathname = location.pathname,
    search = location.search;
  var pathName = pathname + search;
  // If we only want to continue tracking we don't want to add the current URL as a query parameter,
  // but we still want to keep the current query parameters.
  if (onlyContinueTracking) {
    pathName = "";
    // get query parameters from the current URL
    var urlParams = new URLSearchParams(search);
    if (urlParams.has(parameterKey)) {
      var _urlParams_get;
      pathName = (_urlParams_get = urlParams.get(parameterKey)) !== null && _urlParams_get !== void 0 ? _urlParams_get : "";
    }
  }
  // If we have a pathName we want to add it as a query parameter
  if (pathName) {
    query = _object_spread_props(_object_spread({}, query), _define_property({}, parameterKey, pathName));
  }
  // Build the URL
  return buildUrl(segments, query, queryOptions);
};
/**
 * Formats a relative url to be compatible as segments.
 * It returns false if the link is an external link.
 *
 * @param link
 *  The link to format.
 */
export var formatLinkForSegments = function formatLinkForSegments(link) {
  var url = link;
  // 1. check if the link is an external link
  // if it is, return false to prevent further processing.
  if (link.startsWith("http")) {
    return false;
  }
  // 2. split the link into segments.
  var urlParts = url.split("/").filter(Boolean);
  // 3. check if the first segment is '/' if not, add it.
  if (urlParts[0] !== "/") {
    urlParts.unshift("/");
  }
  // 4. return the link segments.
  return urlParts;
};
var internalPrefixes = ["css", "domainPictures", "img", "page-data", "static", "widgets"];
export var isInternalUrl = function isInternalUrl(url) {
  return url.match(new RegExp("^/".concat(internalPrefixes.join("|^/")), "i"));
};
var protectedUrls = ["/sirmed/de/dokumente-und-informationen", "/sirmed/de/unterrichtsunterlagen", "/spz/de/80-stunden-schmerzkurs-referate", "/spz/de/medizinisches-angebot/ambulant-akut-reha/schmerzmedizin/fortbildung-kongresse/80-stunden", "/spz/de/invasive-procedures-motion-20th-anniversary-center-pain-medicine-nottwil-lectures", "/spz/de/update-schmerzmedizin-referate", "/spz/de/80-stunden-schmerzkurs-referate-2020", "/spz/de/interdisziplinaere-multimodale-schmerzmedizin-im-dialog-referate", "/spz/de/medizinisches-angebot/schmerzmedizin/fortbildung-kongresse/dreilaendertagung-achd-2021"];
export var isProtectedUrl = function isProtectedUrl(url) {
  return protectedUrls.includes(url);
};
var localeKeys = Object.keys(locales);
var domainKeys = Object.values(DOMAINS).map(function (domain) {
  var _domain_pathPrefix;
  return (_domain_pathPrefix = domain.pathPrefix) === null || _domain_pathPrefix === void 0 ? void 0 : _domain_pathPrefix.replace(/^\//, "");
}).filter(function (key) {
  return key && key.length > 0;
});
export var isRelativeUrl = function isRelativeUrl(url) {
  return url ? url.charAt(0) === "/" : false;
};
export var getDomainUrl = function getDomainUrl(param) {
  var absoluteUrl = param.absoluteUrl,
    domain = param.domain;
  var urlObject = new URL(absoluteUrl);
  if ((domain === null || domain === void 0 ? void 0 : domain.pathPrefix) && (domain === null || domain === void 0 ? void 0 : domain.pathPrefix) !== "") {
    return "".concat(urlObject.origin).concat(domain.pathPrefix).concat(urlObject.pathname);
    // Fallback based on the query string if the domain path prefix is not set.
  } else if (typeof window !== "undefined") {
    var currentPath = window.location.pathname;
    var pathParts = currentPath.split("/");
    if (pathParts.length > 1) {
      var domainKeys = Object.values(DOMAINS).map(function (domain) {
        var _domain_pathPrefix;
        return (_domain_pathPrefix = domain.pathPrefix) === null || _domain_pathPrefix === void 0 ? void 0 : _domain_pathPrefix.replace(/^\//, "");
      }).filter(function (key) {
        return key && key.length > 0;
      });
      if (domainKeys.includes(pathParts[1])) {
        return "".concat(urlObject.origin, "/").concat(pathParts[1]).concat(urlObject.pathname);
      }
    }
  }
  return absoluteUrl;
};
export var getLocalizedUrl = function getLocalizedUrl(param) {
  var to = param.to,
    locale = param.locale,
    domain = param.domain,
    hash = param.hash;
  var segments = to.split("/").filter(function (seg) {
    return seg.length > 0;
  });
  // If there are no segments or its an internal path, we pass it through without gatsby link handling.
  if (isInternalUrl(to) || !isRelativeUrl(to)) {
    return {
      url: to,
      gatsby: false
    };
  }
  // Split the path into potential language and domain prefixes.
  var path;
  var domainPrefix;
  var localePrefix;
  if (domainKeys.includes(segments[0]) && localeKeys.includes(segments[1])) {
    var ref;
    ref = _to_array(segments), domainPrefix = ref[0], localePrefix = ref[1], path = ref.slice(2), ref;
  } else if (localeKeys.includes(segments[0])) {
    var ref1;
    ref1 = _to_array(segments), localePrefix = ref1[0], path = ref1.slice(1), ref1;
  } else {
    path = segments;
  }
  if ((path.length === 0 || path[0] !== "node") && !localePrefix && !domainPrefix) {
    var _domain_pathPrefix;
    domainPrefix = domain === null || domain === void 0 ? void 0 : (_domain_pathPrefix = domain.pathPrefix) === null || _domain_pathPrefix === void 0 ? void 0 : _domain_pathPrefix.replace(/^\//, "");
    localePrefix = locale;
  }
  var homePagePath = DOMAINS["paraplegie_ch"].homepagePath;
  if (domain) {
    homePagePath = domain.homepagePath;
  }
  var homePageSegment = homePagePath.replace("/", "");
  return {
    // Build the url and replace languages if explicitly required.
    url: [buildUrl(["/", domainPrefix, localePrefix].concat(_to_consumable_array(path.filter(function (seg) {
      return seg !== homePageSegment;
    })))), hash].join(""),
    // If the path has no locale prefix, it's not a reliable
    // one and should not be enhanced by Gatsby.
    gatsby: !!localePrefix || path.length === 0
  };
};
/**
 * Get the contact url for the given domain and language. Hardcoded urls.
 */
export var getContactUrl = function getContactUrl(url, domain, language) {
  var urlToSwitch = url;
  switch (domain === null || domain === void 0 ? void 0 : domain.id) {
    case "paraplegie_ch":
    case "stiftung_paraplegie_ch":
    case "gonner_vereinigung_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/de/wichtige-kontakte/";
          break;
        case "en":
          urlToSwitch = "/en/important-contacts/";
          break;
        case "fr":
          urlToSwitch = "/fr/principaux-contacts/";
          break;
        case "it":
          urlToSwitch = "/it/contatti-importanti/";
          break;
      }
      break;
    case "zentrum_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/spz/de/kontakt-spz/";
          break;
        case "en":
          urlToSwitch = "/spz/en/contact-spc/";
          break;
        case "fr":
          urlToSwitch = "/spz/fr/contact-csp/";
          break;
        case "it":
          urlToSwitch = "/spz/it/contatto-csp/";
          break;
      }
      break;
    case "parahelp_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/parahelp/de/kontakt-parahelp/";
          break;
        case "en":
          urlToSwitch = "/parahelp/de/kontakt-parahelp/";
          break;
        case "fr":
          urlToSwitch = "/parahelp/fr/contact-parahelp/";
          break;
        case "it":
          urlToSwitch = "/parahelp/it/contatto-parahelp/";
          break;
      }
      break;
    case "forschung_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/spf/de/kontakt-spf/";
          break;
        case "en":
          urlToSwitch = "/spf/en/contact-spf/";
          break;
        case "fr":
          urlToSwitch = "/spf/fr/contact-rsp/";
          break;
        case "it":
          urlToSwitch = "/spf/it/contatto-rsp/";
          break;
      }
      break;
    case "sirmed_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/sirmed/de/ueber-uns/kontakt/wo-sie-uns-finden/";
          break;
        case "en":
          urlToSwitch = "/sirmed/en/about-us/kontakt/where-find-us-0/";
          break;
        case "fr":
          urlToSwitch = "/sirmed/fr/portrait/contact/ou-nous-trouver-0/";
          break;
        case "it":
          urlToSwitch = "/sirmed/it/chi-siamo/contatto/dove-trovarci/";
          break;
      }
      break;
    case "orthotec_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/orthotec/de/ueber-uns/kontaktieren-sie-uns/wo-sie-uns-finden/";
          break;
        case "en":
          urlToSwitch = "/orthotec/en/about-us/contact-us/where-find-us/";
          break;
        case "fr":
          urlToSwitch = "/orthotec/fr/notre-portrait/sites-et-heures-douverture/ou-nous-trouver/";
          break;
        case "it":
          urlToSwitch = "/orthotec/it/chi-siamo/sedi-e-orari-di-apertura/dove-trovarci/";
          break;
      }
      break;
    case "activecommunication_paraplegie_ch":
      switch (language) {
        case "de":
          urlToSwitch = "/activecommunication/de/kontakt-ac/";
          break;
        case "en":
          urlToSwitch = "/activecommunication/de/kontakt-ac/";
          break;
        case "fr":
          urlToSwitch = "/activecommunication/fr/contact-ac/";
          break;
        case "it":
          urlToSwitch = "/activecommunication/de/kontakt-ac/";
          break;
      }
      break;
  }
  return urlToSwitch;
};
export var getTranslatedUrl = function getTranslatedUrl(param) {
  var urlObject = param.urlObject,
    langcode = param.langcode;
  var _match__link, _urlObject__link;
  var match = urlObject.filter(function (el) {
    return (el === null || el === void 0 ? void 0 : el.langcode) === langcode;
  });
  // First will try and from the filtered object, if not found will try and get the first one as fallback.
  if (match.length > 0 && ((_match__link = match[0].link) === null || _match__link === void 0 ? void 0 : _match__link.url)) {
    return match[0].link.url;
  } else if (urlObject.length > 1 && ((_urlObject__link = urlObject[0].link) === null || _urlObject__link === void 0 ? void 0 : _urlObject__link.url)) {
    urlObject[0].link.url;
  }
  return "/";
};